import { FlagOutlined } from '@ant-design/icons';
import { Datatype } from '@framework/engine/schema/expressions/datatype/Datatype.ts';
import { getSimpleWidgetReference } from '@framework/engine/schema/expressions/references/builder/getSimpleWidgetReference.ts';
import { RequiredRule } from '@framework/engine/schema/rules/repository/required/Required.rule.ts';
import { tran } from '@framework/engine/schema/translations/schema/TranslationSchema.ts';
import { type IWidgetType } from '@framework/engine/schema/widgets/IWidgetType.ts';
import {
  WidgetCategory,
  WidgetMainType,
} from '@framework/engine/schema/widgets/Widget.ts';
import { CompetenceWidgetComponent } from './CompetenceWidgetComponent.tsx';
import {
  CompetenceInputConfigComponent,
  CompetenceWidgetConfigSchema,
} from './CompetenceWidgetConfigComponent.tsx';
import { createCompetenceSelectFormSchema } from './createCompetenceSelectFormSchema.ts';
import { hydrateCompetenceWidget } from './hydrateCompetenceWidget.ts';
import {
  type ICompetenceWidget,
  WidgetTypeCompetence,
} from './ICompetenceWidget.ts';

declare module '@framework/engine/schema/widgets/Widget.ts' {
  export enum WidgetType {
    Competence = 'competence',
  }
}

export const CompetenceWidgetType: IWidgetType<ICompetenceWidget> = {
  type: WidgetTypeCompetence,
  mainType: WidgetMainType.Input,
  category: WidgetCategory.Advanced,
  name: 'Selezione Competenza',
  icon: <FlagOutlined />,
  hasValue: true,
  hydrate: hydrateCompetenceWidget,
  getReference: getSimpleWidgetReference(Datatype.String),
  getSiblingReferences: () => [],
  formComponent: CompetenceWidgetComponent,
  createFormSchema: createCompetenceSelectFormSchema,
  previewComponent: CompetenceWidgetComponent,
  configValidator: CompetenceWidgetConfigSchema,
  configComponent: CompetenceInputConfigComponent,
  configOptions: {},
  // Traduzioni
  translationSchema: tran.widget({
    label: tran.rte(),
  }),
  rules: [RequiredRule],
};
